import React, { Component, Fragment } from 'react';
import { withRouter } from '../../WithRouterHOC';
import { Modal, message, Button } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import BuyMessage from '../BuyMessage/BuyMessage';
import HTTP from '../../../script/service';
import Util from '../../../script/util';
import {
  _get_user_info,
  _h5_link_to,
  _change_affinity_modal,
} from '../../../store/Action';
import Recharge from '../../recharge/Recharge';
import SearchUser from '../SearchUser/SearchUser';
import IframeModal from '../../iframModal/IframModal';
import qs from 'qs';
import './BuyModal.scss';
import PrettyNum from '../../prettyNum/PrettyNum';
import WebglVideo from '../../webglVideo/indexNew';

const BARRAGE_UNIT_PRICE = 100; // 弹幕数量 单价100钻

class BuyModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false, // 按钮 Loading
      visible: false,
      num: 1, // 数量
      tabIndex: 1, // 当前选中的SKU
      goodsDetails: null, // 奖品详情
      skuList: null, // SKU列表
      currentSku: null, // 当前选中的SKU
      isPopUps: false, // 是否展示购买弹幕
    };
  }

  // 商品详情
  queryPropSkuList = (items, bool = false) => {
    const { base } = this.props;

    const params = {
      uid: base.uid,
      goodsId: items.id,
    };
    HTTP._query_prop_sku_list(params).then((res) => {
      if (res.code === 200) {
        const goodsDetails = res.data.goods;
        const skuList = res.data.skuList || null;
        const currentSku = skuList && skuList ? res.data.skuList[0] : null;
        const tabIndex = currentSku ? currentSku.id : 1;
        this.setState({
          visible: !!bool,
          goodsDetails: { ...items, ...goodsDetails },
          skuList,
          currentSku,
          tabIndex,
        });
      } else {
        message.error((res && res.message) || '获取商品失败');
      }
    });
  };

  // 展示
  showModal = (items, isPopUps = false) => {
    this.setState({ isPopUps });
    if (isPopUps) {
      const goodsDetails = {
        link: '',
        goodsName: '房间弹幕',
        remark: '用于房间语聊中的弹幕交流',
      };
      this.setState({ visible: true, goodsDetails });
    } else {
      if (items) {
        this.queryPropSkuList(items, true);
      } else {
        message.warning('异常');
      }
    }
  };
  // 关闭
  hideModal = (e) => {
     e&& e.preventDefault();

    // 销毁SVGA
    if (this.seniorEffectsPlayer?.stopAnimation) {
      this.seniorEffectsPlayer.stopAnimation();
      this.seniorEffectsPlayer.clear();
      this.seniorEffectsPlayer.clearDynamicObjects();
    } else if (this.seniorEffectsPlayer?.stop) {
      this.seniorEffectsPlayer.stop();
    }
    this.seniorEffectsPlayer = null;
    clearTimeout(this.animationSvgaTiem);

    // 关闭弹窗初始化数据
    const resetState = {
      num: 1,
      tabIndex: 1,
      goodsDetails: null,
      skuList: null,
      isPopUps: false,
    };
    this.searchUserEl.hideModal(e); // 关闭搜索弹窗
    this.setState({ visible: false, ...resetState });
  };

  // 去充值
  handleOpenRecharge = (e) => {
    this.hideModal(e);
    const { currentSku, num, isPopUps } = this.state;
    let price = 100;
    if (currentSku) {
      const skuPrice = isPopUps ? 100 * num : currentSku.skuPrice;
      price = skuPrice / 100 < 1 ? 1 : skuPrice / 100;
    }
    this.RechargeElement.showModal(2, price);
  };

  // 改变 Tab Index
  changeTabIndex = (item) => {
    this.setState({
      tabIndex: Number(item.id),
      currentSku: item,
    });
  };

  // 增加/减少数量
  changePrizeNum = (number) => {
    const { num } = this.state;

    if (number === -1) {
      if (num <= 1) {
        return;
      }
    }
    this.setState({ num: num + number });
  };

  // 赠送弹窗
  handleSendUser = (e) => {
    const { goodsDetails, currentSku, isPopUps, num } = this.state;
    this.hideModal(e);
    const sku = currentSku || {};
    if (isPopUps) {
      sku.num = num;
      sku.skuPrice = BARRAGE_UNIT_PRICE * num;
    }
    this.searchUserEl.showModal(goodsDetails, sku, isPopUps);
  };

  // 支付按钮
  changeButtonText = () => {
    const {
      base: { userInfo },
    } = this.props;
    const { loading, currentSku, goodsDetails, isPopUps, num } = this.state;
    const myLevel = parseInt(userInfo.wealthLevel.split('_')[0]);
    let disabled = false;
    let skuPrice = 0;
    let textDom = <span>已售罄</span>;
    if (isPopUps) {
      // 弹幕过滤库存之类的
      // 购买弹幕数量单独处理
      skuPrice = BARRAGE_UNIT_PRICE * num;
    } else {
      // 活动专属，暂未开始销售
      if (!!goodsDetails.isBuy) {
        disabled = true;
        textDom = <span>活动特权专属，暂不对外售卖</span>;
      } else {
        if (!currentSku) {
          // SKU 都没有，所以异常状态
          disabled = true;
          textDom = <span>暂未开启销售，无法购买</span>;
        } else {
          skuPrice = currentSku.skuPrice;
          // 暂未开始销售
          if (goodsDetails.status === 0) {
            disabled = true;
            textDom = <span>暂未开始销售，无法购买</span>;
          }
          // 已售罄
          else if (goodsDetails.status === 2) {
            disabled = true;
            textDom = <span>已售罄</span>;
          }
          // 等级不够，无法购买
          else if (myLevel < goodsDetails.wealthLevel) {
            disabled = true;
            textDom = <span>财富等级不够，无法购买</span>;
          } else if (currentSku.stock <= 0) {
            // 商品已删除 || 商品库存不足
            disabled = true;
            textDom = <span>已售罄</span>;
          }
        }
      }
    }

    if (!disabled) {
      // 余额不足无法购买
      if (userInfo.diamondAmount < skuPrice) {
        disabled = true;
        textDom = <span>余额不足，无法购买</span>;
      } else {
        // 所有条件都满足，计算需要支付金额
        disabled = false;
        textDom = (
          <Fragment>
            <span>支付</span>
            <i className="icon-diamond" />
            <span>{skuPrice}</span>
          </Fragment>
        );
      }
    }
    return (
      <div className="buy-props-btn-wrap">
        <Button
          loading={loading}
          disabled={disabled}
          className="daidai-btn-primary props-btn-pay"
          onClick={disabled ? null : () => this.handleBuyProp(currentSku)}
        >
          {textDom}
        </Button>
        {goodsDetails.categoryId != -32 && goodsDetails.categoryId != 34 ? (
          <Button
            disabled={disabled}
            ghost
            danger
            className="daidai-btn props-btn-send"
            onClick={disabled ? null : this.handleSendUser}
          >
            赠送
          </Button>
        ) : null}
      </div>
    );
  };

  // 赠送
  handleGive = (e) => {
    const { goodsDetails, currentSku } = this.state;
    this.BuyMessageEle.hideModal();
    this.hideModal()
    let detail = {
      ...goodsDetails,
      propId: goodsDetails?.propGoodsId,
      id: goodsDetails?.buyId,
      name: goodsDetails?.goodsName,
      remark: goodsDetails?.goodsRemark,
    };
    _change_affinity_modal({
      affinityGiveModal: true,
      affinityGiveData: {
        detail: detail,
        type: goodsDetails.categoryId,
        isBuy: true,
        num: currentSku.num,
      },
    });
  };
  //缔结新关系
  handleNewAffinity = () => {
    const { goodsDetails } = this.state;
    let data = {
      id: goodsDetails.propGoodsId,
      name: goodsDetails.goodsName,
      remark: goodsDetails.goodsRemark,
      otherTip: goodsDetails.otherTip,
      titlePic: goodsDetails.titlePic,
    };
    _change_affinity_modal({
      affinityInviteModal: true,
      affinityInviteData: data,
    });

    this.hideModal()
    this.BuyMessageEle.hideModal();
  };

  // 购买
  handleBuyProp = (sku, giveUser = null, callback = null) => {
    const { base, buySuccessCallback } = this.props;
    const { isPopUps, num, goodsDetails } = this.state;
    if (sku || isPopUps) {
      this.setState({ loading: true }, () => {
        const params = {
          uid: base.uid,
          orderCount: num,
          skuId: isPopUps ? -1 : sku.id,
        };
        // 赠送 添加字段
        if (giveUser) {
          params.giveUid = giveUser.otherUid;
          // 赠送弹幕
          if (giveUser.isPopUps) {
            params.skuId = -1;
            params.orderCount = giveUser.num;
          }
        }
        HTTP._buy_prop(params)
          .then((res) => {
            if (res.code === 200) {
              callback && callback(true);
              this.setState({
                goodsDetails: { ...goodsDetails, buyId: res.data.id },
              });
              const title = giveUser ? '赠送成功' : '购买成功';
              let skuName = res.data.skuName;
              let skuNum = isPopUps ? num : sku.num;
              let skuUnit = isPopUps
                ? `${num}个`
                : this.timeUnit(skuNum, sku.unit);
              let descText = isPopUps
                ? '可在“我的道具”->“弹幕”中查看数量'
                : '，如需装扮请在“我的道具”中设置';
              let affinityBtn1, affinityBtn2;
              if (res.data?.propTypeId == -32) {
                descText = '，可以用它和好友缔结亲密关系啦~';
                affinityBtn1 = (
                  <Button
                    className="daidai-btn-primary props-btn-pay"
                    onClick={this.handleGive}
                    style={{ width: '226px' }}
                  >
                    送给亲密关系好友
                  </Button>
                );
                affinityBtn2 = (
                  <Button
                    className="daidai-btn props-btn-new-affinity"
                    ghost
                    danger
                    onClick={this.handleNewAffinity}
                  >
                    缔结新关系
                  </Button>
                );
              } else if (res.data?.propTypeId == 34) {
                descText = '，可以和亲密关系好友发展趣味关系啦~';
                affinityBtn1 = (
                  <Button
                    className="daidai-btn-primary props-btn-pay"
                    onClick={this.handleGive}
                    style={{ width: '300px' }}
                  >
                    送给亲密关系好友
                  </Button>
                );
              }
              if (giveUser) {
                // 赠送弹幕文案展示
                skuName = giveUser.goodsName;
                if (giveUser.isPopUps) {
                  skuUnit = `${giveUser.num}个`;
                } else {
                  // 非弹幕数量 需要重新请求 SKU 数据
                  this.queryPropSkuList(giveUser);
                }
                descText = `给${giveUser.remarkName || ''}(UID:${giveUser.otherUid})`;
              } else {
                if (buySuccessCallback != null) {
                  buySuccessCallback(true);
                }
              }
              const msg = `您已${giveUser ? '赠送' : '购买'}${skuName}*${skuUnit}${descText}`;
              this.BuyMessageEle.showModal(
                true,
                title,
                msg,
                affinityBtn1,
                affinityBtn2
              );
            } else {
              let msg = res?.message || '购买失败请稍后重试';
              if (res?.code === 400) {
                msg = '请求过于频繁，请稍后再试';
              }
              if (res?.code !== 5505) {
                this.BuyMessageEle.showModal(false, '购买失败', msg);
              } else {
                message.warning(msg);
              }

              callback && callback(false);
            }

            _get_user_info({ qKey: 'BuyModal' });
          })
          .catch(() => {
            callback && callback(false);
          })
          .finally(() => {
            this.setState({ loading: false });
          });
      });
    } else {
      message.warning('请正确选择需要购买的商品');
    }
  };

  // 打开links
  handleGotoLinks = () => {
    const { goodsDetails } = this.state;
    const { link } = goodsDetails;
    if (!!link) {
      _h5_link_to(link).then((res) => {
        this.iframeElement.showModal(link + '?' + qs.stringify(res.params));
      });
    }
  };

  // 处理预览详情展示图片
  renderPropImg = () => {
    const {
      base: { userInfo },
    } = this.props;
    const { goodsDetails, visible } = this.state;
    let className = 'mall-center';
    const nickname = userInfo.nickname;
    const beautifulNo = goodsDetails.beautifulNo || null;
    if (goodsDetails.categoryId === 1 || goodsDetails.categoryId === 14) {
      // 麦位框
      className += ' bubble-prop';

      return (
        <div className={className}>
          <div className="cover">
            <img
              src={Util.transImgUrl(userInfo.avatar, '200x200')}
              alt={nickname}
            />
          </div>
          <div className="prop-box">
            <img
              src={Util.transImgUrl(goodsDetails.prePic)}
              alt={goodsDetails.goodsName}
            />
          </div>
        </div>
      );
    }
    const isSvga =
      goodsDetails?.prePic?.indexOf('.svga') > -1 ||
      goodsDetails?.prePic?.indexOf('.mp4') > -1 ||
      false;
    if (isSvga && visible) {
      const nickName = nickname
        ? nickname.length > 7
          ? `${nickname.substr(0, 6)}...`
          : nickname
        : '';
      if (goodsDetails.prePic.indexOf('.svga') > -1) {
        // SVGA 素材单独处理
        if (!window._SVGA) return;
        this.animationSvgaTiem = setTimeout(() => {
          this.seniorEffectsPlayer = new window.SVGA.Player('#propBox');
          this.svgaParser = new window.SVGA.Parser('#propBox');
          const userJoinRoom = {
            text: `${nickName} 来啦`,
            color: '#faff00',
            family: 'Noto Sans SC',
            size: '40px',
            offset: { x: -30.0, y: 0.0 },
          };

          // 初始化SVGA
          this.svgaParser.load(
            Util.transImgUrl(goodsDetails.prePic),
            (videoItem) => {
              this.seniorEffectsPlayer.loops = 0; // 播放次数
              this.seniorEffectsPlayer.setText(userJoinRoom, 'wenzi_kong750');

              this.seniorEffectsPlayer.setVideoItem(videoItem);
              this.seniorEffectsPlayer.startAnimation();

              this.seniorEffectsPlayer.clearsAfterStop = true;
            }
          );
        }, 200);
      } else if (goodsDetails.prePic.indexOf('.mp4') > -1) {
        this.seniorEffectsTime = setTimeout(async () => {
          this.seniorEffectsPlayer = await WebglVideo({
            container: this.propBoxEle,
            src: Util.transImgUrl(goodsDetails.prePic),
            loop: true,
            effects: {
              dingwei: {
                text: `${nickName} 来啦`,
                fontStyle: `40px Noto Sans SC`,
                fontColor: '#666666',
              },
            },
          });
        }, 200);
      }
    }
    return (
      <div className={className}>
        <div
          className="prop-box"
          id="propBox"
          ref={(el) => (this.propBoxEle = el)}
        >
          {isSvga ? null : !!beautifulNo ? (
            <div className="beautiful-no">
              <PrettyNum isBright num={beautifulNo} />
            </div>
          ) : (
            <img
              src={Util.transImgUrl(goodsDetails.prePic)}
              alt={goodsDetails.goodsName}
            />
          )}
        </div>
      </div>
    );
  };

  // 处理时间单位
  timeUnit = (num, unit) => {
    // 0:天,1:小时,2:个数
    let unitText = '';
    switch (Number(unit)) {
      case 0:
        unitText = '天';
        break;
      case 1:
        unitText = '小时';
        break;
      case 2:
        unitText = '个';
        break;
      default:
        unitText = '天';
        break;
    }

    return num < 0 ? '永久' : `${num}${unitText}`;
  };

  render() {
    const {
      base: { userLevel, userInfo },
    } = this.props;
    const { visible, tabIndex, goodsDetails, skuList, num, isPopUps } =
      this.state;
    return (
      <>
        <Modal
          open={visible}
          title="道具预览"
          onCancel={this.hideModal}
          width={400}
          footer={null}
          centered={true}
          keyboard={false}
          maskClosable={false}
          wrapClassName="daidai-modal-style has-top-border props-preview"
        >
          {goodsDetails ? (
            <Fragment>
              <div
                className="preview-img"
                style={{
                  backgroundImage: goodsDetails.backgroundPic
                    ? `url(${Util.transImgUrl(goodsDetails.backgroundPic)})`
                    : 'none',
                }}
              >
                {!isPopUps && goodsDetails.wealthLevel ? (
                  <div className="type-level">
                    {userLevel[goodsDetails.wealthLevel]}以上专属
                  </div>
                ) : null}
                {isPopUps ? (
                  <div
                    className="mall-center"
                    style={{
                      backgroundColor: '#29599d',
                      backgroundImage: 'none',
                    }}
                  >
                    <span className="pop-up-text">6666~</span>
                  </div>
                ) : (
                  this.renderPropImg()
                )}
                {goodsDetails?.rarityConfig ? (
                  <div className="rarity">
                    <img
                      src={Util.transImgUrl(
                        goodsDetails?.rarityConfig?.labelImg
                      )}
                      alt=""
                    />
                  </div>
                ) : null}
                <div className="masking" />
              </div>
              <div className="preview-desc">
                <h3 className="name">{goodsDetails.goodsName}</h3>
                <p className="desc">
                  {goodsDetails.goodsRemark || <span>&nbsp;&nbsp;&nbsp;</span>}
                </p>
                <p className="desc">
                  {goodsDetails.otherTip || <span>&nbsp;&nbsp;&nbsp;</span>}
                </p>
              </div>
              {isPopUps ? (
                <div className="pop-price-info">
                  <div className="price-wrap">
                    <i className="icon-diamond" />
                    <span>{BARRAGE_UNIT_PRICE}/个</span>
                  </div>
                  <div className="number-box">
                    <span
                      className="num-del"
                      onClick={() => this.changePrizeNum(-1)}
                    >
                      <MinusOutlined />
                    </span>
                    <span className="num-tt">{num}</span>
                    <span
                      className="num-add"
                      onClick={() => this.changePrizeNum(1)}
                    >
                      <PlusOutlined />
                    </span>
                  </div>
                </div>
              ) : skuList && skuList.length ? (
                <ul className="props-price">
                  {skuList.map((item) => (
                    <li
                      key={item.id}
                      className={`item-price ${tabIndex === item.id ? 'active' : ''}`}
                      onClick={() => this.changeTabIndex(item)}
                    >
                      <p className="expiry-date">
                        {item.validityTime}
                        {this.timeUnit(item.num, item.unit)}
                      </p>
                      <p className="price-wrap">
                        <span className="price">{item.skuPrice}</span>
                        <i className="icon-diamond" />
                      </p>
                    </li>
                  ))}
                </ul>
              ) : null}
              {this.changeButtonText()}
              <p className="props-footer">
                {!!goodsDetails.isBuy && goodsDetails.link ? (
                  <span className="link" onClick={this.handleGotoLinks}>
                    去看看怎么获得吧&gt;&gt;
                  </span>
                ) : (
                  <Fragment>
                    我的钻石: {Util.numberFormat(userInfo.diamondAmount)}
                    &nbsp;&nbsp;
                    <span className="link" onClick={this.handleOpenRecharge}>
                      去充值
                    </span>
                  </Fragment>
                )}
              </p>
            </Fragment>
          ) : null}
        </Modal>
        {/* 购买回馈 */}
        <BuyMessage
          wrappedComponentRef={(el) => (this.BuyMessageEle = el)}
          parentHide={this.hideModal}
        />
        {/* 充值模块 */}
        <Recharge
          wrappedComponentRef={(el) => (this.RechargeElement = el)}
          base={this.props.base}
          showMyCenter={this.props.showMyCenter}
        />
        {/*赠送搜索用户弹窗*/}
        <SearchUser
          wrappedComponentRef={(el) => (this.searchUserEl = el)}
          base={this.props.base}
          handleBuyProp={this.handleBuyProp}
          parentHide={this.hideModal}
          timeUnit={this.timeUnit}
        />
        {/* 立即获取 */}
        <IframeModal wrappedComponentRef={(el) => (this.iframeElement = el)} />
      </>
    );
  }
}
export default withRouter(BuyModal, { withRef: true });

BuyModal.defaultProps = {
  popUpsColor: '#FFF', // 弹幕颜色
};
